<template>
    <div>
        <div class="modal-body" style="max-height: 70vh; overflow: auto;">
            <div ref="hotContainer" class="hot-container"></div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-success" @click="saveChanges">Salva Excel</button>
        </div>
    </div>
</template>

<script>
import Handsontable from 'handsontable';
import 'handsontable/dist/handsontable.full.min.css';
import * as XLSX from 'xlsx';

export default {
    name: 'ExcelEditor',
    props: {
        file: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            filePath: this.file.fullPath,
            hotInstance: null,
            originalWorkbook: null,
        };
    },
    mounted() {
        this.loadExcel();
    },
    methods: {
        loadExcel() {
            this.fetchExcelBlob(this.filePath)
                .then(arrayBuffer => this.parseWorkbook(arrayBuffer))
                .then(workbook => this.initHandsontable(workbook))
                .catch(err => console.error('Errore nel caricamento Excel:', err));
        },

        fetchExcelBlob(path) {
            return new Promise((resolve, reject) => {
                utils.ajaxBlob('ftp/get-excel', { path }, blob => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsArrayBuffer(blob);
                }, true, 'GET');
            });
        },

        parseWorkbook(arrayBuffer) {
            try {
                const wb = XLSX.read(arrayBuffer, { type: 'array' });
                this.originalWorkbook = wb;
                return wb;
            } catch (e) {
                throw new Error('Errore parsing workbook: ' + e.message);
            }
        },

        initHandsontable(workbook) {
            const sheetName = workbook.SheetNames[0];
            const data = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 });

            this.$nextTick(() => {
                if (!this.$refs.hotContainer) {
                    console.error('hotContainer non trovato');
                    return;
                }

                if (this.hotInstance) this.hotInstance.destroy();

                this.hotInstance = new Handsontable(this.$refs.hotContainer, {
                    data,
                    rowHeaders: true,
                    colHeaders: true,
                    contextMenu: true,
                    dropdownMenu: true,
                    manualRowResize: true,
                    manualColumnResize: true,
                    manualRowMove: true,
                    manualColumnMove: true,
                    minSpareRows: 1,
                    width: '100%',
                    height: '100%',
                    stretchH: 'all',
                    licenseKey: 'non-commercial-and-evaluation',
                });

                console.log('Handsontable inizializzato');
            });
        },

        saveChanges() {
            const wbBlob = this.generateUpdatedBlob();
            if (!wbBlob) return;

            const formData = new FormData();
            formData.append('file', new File([wbBlob], 'modificato.xlsx'));
            formData.append('path', this.filePath);

            utils.uploadAjax('ftp/save-excel', formData, response => {
                if (response.esito == 0) {
                    utils.alert.success('Excel salvato con successo');
                    this.$emit('salvato');
                } else {
                    utils.alert.error(response.messaggio || 'Errore durante il salvataggio');
                }
            }, true);
        },

        generateUpdatedBlob() {
            if (!this.hotInstance) {
                utils.alert.error('Nessuna tabella da salvare');
                return null;
            }

            const data = this.hotInstance.getData();
            const ws = XLSX.utils.aoa_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Foglio1');

            const binary = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
            const buf = new ArrayBuffer(binary.length);
            const view = new Uint8Array(buf);

            for (let i = 0; i < binary.length; i++) {
                view[i] = binary.charCodeAt(i) & 0xFF;
            }

            return new Blob([buf], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
        }
    }
};

</script>

<style scoped>
.modal-xl {
    max-width: 95vw;
}

.modal-body {
    max-height: 70vh;
    overflow: auto;
}

.hot-container {
    width: 100%;
    min-height: 400px;
    max-height: 100%;
    overflow: auto;
}
</style>
